import { render } from "./AgentWizardDialog.vue?vue&type=template&id=4d57f969&scoped=true&ts=true"
import script from "./AgentWizardDialog.vue?vue&type=script&lang=ts"
export * from "./AgentWizardDialog.vue?vue&type=script&lang=ts"

import "./AgentWizardDialog.vue?vue&type=style&index=0&id=4d57f969&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d57f969"]])

export default __exports__